function o({props:o,states:r,muiFormControl:t}){return r.reduce(((r,e)=>(r[e]=o[e],t&&void 0===o[e]&&(r[e]=t[e]),r)),{})}export{o as f};
